<template>
  <div>
    <div class="order-h1" :class="getClass(orderDeatilsData)">
      <i class="iconfont" :class="returnImg(orderDeatilsData)"></i>
      {{ getStatus(orderDeatilsData) }}
    </div>
    <div class="order-h2">
      <div class="order-h2-left">
        订单号：{{ orderCode }}
        <span>订单类型：{{ orderTypeName }}</span>
      </div>
      <div class="order-h2-right">
        <div
          v-if="
            (orderDeatilsData.orderStatus == 2 || orderDeatilsData.refundStatus != 0) &&
            orderDeatilsData.orderType != 6 &&
            orderDeatilsData.orderType != 5
          "
        >
          <i :class="refreshStatus ? 'el-icon-loading' : 'el-icon-refresh'" @click="getPrinterList"></i>
          <span class="titlte">当前打印机设备号：</span>
          <el-dropdown v-if="printerId || printerName" trigger="click" class="order-dropdown" @command="choosePrinter">
            <span class="el-dropdown-link">
              {{ printerName }}
              <!-- v-if="printerName!='暂无可用设备'" -->
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu v-if="printerList.length > 0" slot="dropdown" size="medium" @click="choosePrinter">
              <el-dropdown-item
                v-for="(v, n) in printerList"
                :key="n"
                :command="v.id + ',' + v.printerName"
                :disabled="v.printerState == 0 ? true : false"
                >{{ v.printerName }}{{ v.printerState == 0 ? '（不在线）' : '' }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <label v-else>
            <span class="theme-red">未连接</span>
            <span class="theme-blue" @click="jumpSetPrinter">前往设置</span>
          </label>
          <el-button v-if="printerId" type="primary" @click="printOrder(1)">打印小票</el-button>
          <el-button
            v-if="orderDeatilsData.orderType != 8 && orderDeatilsData.orderType != 5 && orderDeatilsData.orderType != 9"
            type="primary"
            @click.stop="aFourPrint()"
            >A4打印</el-button
          >
        </div>
        <div
          v-if="
            ((orderDeatilsData.orderStatus == 2 ||
              (orderDeatilsData.partPayType == 1 && orderDeatilsData.balance > 0) ||
              orderDeatilsData.refundStatus != 0) &&
              orderDeatilsData.orderType != 5 &&
              orderDeatilsData.orderType != 6 &&
              orderDeatilsData.refundStatus != 4 &&
              orderDeatilsData.allGiftOrderStatus != 1 &&
              settlementCode != '优惠全额抵扣' &&
              refundBtnStatus()) ||
            (settlementCode == '优惠全额抵扣' && orderDeatilsData.deductAmount * 1 > 0)
          "
        >
          <el-button
            v-show="
              orderDeatilsData.refundStatus != 4 || (orderDeatilsData.bookOrderMsgDTO && orderDeatilsData.bookOrderMsgDTO.bookStatus !== -4)
            "
            style="margin-left: 10px"
            @click="refund(orderDeatilsData.orderType, orderDeatilsData.orderId)"
            >退款</el-button
          >
        </div>
      </div>
    </div>

    <!--打印弹框-->
    <el-dialog title="预览" :visible.sync="showTemplateList" :append-to-body="true" width="560px">
      <ul v-if="templateList.length > 0" class="a4-template-care">
        <li v-for="item in templateList" :key="item.id" @click="selectTemplateId(item)">
          {{ item.templateName }}
        </li>
      </ul>
      <ul v-else class="a4-template-care a4-template-care-no">
        暂无模板
      </ul>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="showTemplate" :append-to-body="true" width="960px">
      <!-- eslint-disable-next-line vue/no-v-html-->
      <div class="a4-template-html" v-html="templateData"></div>
      <span slot="footer" class="dialog-footer">
        <el-pagination
          :current-page.sync="pageNum"
          :page-size="1"
          layout="total, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
        <el-button @click="openpdf()">PDF下载</el-button>
        <el-button @click="showTemplate = false">取 消</el-button>
        <el-button v-if="printerId" type="primary" @click="saveDy">打 印</el-button>
      </span>
    </el-dialog>

    <!--退款-->
    <el-dialog title="退款" :visible.sync="refundDialog" :append-to-body="true" width="1000px">
      <div slot="title" class="header-title">
        <span style="font-size: 14px; font-weight: 600">退款</span>
        <el-popover placement="right" width="500" trigger="hover">
          <div style="padding: 10px">
            <p>1.退款页面不可修改员工业绩与提成，商家可在“员工业绩与提成”进行修改</p>
            <p>2.修改业绩提成后产生的退款提成将在本月进行扣除</p>
            <p>3.“销售达标提成”、“劳动达标提成”不可修改与扣除</p>
            <p>4.粉丝端预约定金，暂不支持线上退还</p>
          </div>
          <i slot="reference" style="color: #d2d2d2; font-size: 14px" class="el-icon-warning"></i>
        </el-popover>
      </div>
      <div class="order-details">
        <div v-if="refundData.vipCardMsg4RefundList.length > 0" class="box">
          <div class="title" style="margin-bottom: 10px">套餐概况</div>
          <el-table :data="refundData.vipCardMsg4RefundList" tooltip-effect="light">
            <el-table-column label="套餐名称" :show-overflow-tooltip="true" prop="vipCardName"></el-table-column>
            <el-table-column label="购买金额" :show-overflow-tooltip="true" prop="amount"></el-table-column>
            <el-table-column label="数量" :show-overflow-tooltip="true" prop="buyCount"></el-table-column>
            <el-table-column label="总次数" :show-overflow-tooltip="true" prop="discount">
              <template slot-scope="scope">
                <span>{{
                  scope.row.countLimitType === 2 ? '无限次数' : scope.row.countLimitType !== 2 ? scope.row.allCount + '次' : '-'
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="已使用" :show-overflow-tooltip="true" prop="discount">
              <template slot-scope="scope">
                <span>{{ scope.row.useCount ? scope.row.useCount + '次' : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="套餐权益" :show-overflow-tooltip="true" prop="discount">
              <template slot-scope="scope">
                <el-popover placement="bottom" trigger="click">
                  <div class="order-popover">
                    <p v-for="(item, index) in scope.row.vipCardItemList" :key="index">
                      <span
                        :class="
                          item.typeName == '项目'
                            ? 'title' + ' ' + 'backg-bule'
                            : item.typeName == '产品'
                            ? 'title' + ' ' + 'backg-gree'
                            : 'title'
                        "
                        >{{ item.typeName }}</span
                      >
                      <span class="text mgl">{{ item.itemName }}</span>
                      <span class="text textright"
                        >{{
                          item.countLimitType == 2
                            ? '无限次数'
                            : item.countLimitType == 1
                            ? item.allCount + '次'
                            : item.countLimitType == 3
                            ? ''
                            : '0次'
                        }}
                        已使用({{ item.useCount ? item.useCount : '0' }})次</span
                      >
                    </p>
                  </div>
                  <el-button slot="reference" type="text">查看 </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="box">
          <div class="title" style="margin-bottom: 10px">订单修改</div>
          <el-table :data="refundData.itemList" tooltip-effect="light">
            <el-table-column label="项目/产品/套餐" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.name || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="原价" width="90px" :show-overflow-tooltip="true"> </el-table-column>
            <el-table-column label="折后价" width="90px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{
                  scope.row.discountMoney
                    ? (scope.row.discountMoney * 1).toFixed(2)
                    : ((scope.row.price * scope.row.discount) / 10).toFixed(2)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量" width="90px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.refundType == 2 || scope.row.refundType == 3 || scope.row.refundType == 4"
                  v-model="scope.row.refundNum"
                  size="mini"
                  oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '').replace('.','')"
                  @change="refundNumChange(scope.$index, scope.row.refundNum, scope.row.count, scope.row.refundCount)"
                ></el-input>
                <span v-else>{{ scope.row.count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠价" width="110px" :show-overflow-tooltip="true">
              <template slot="header">
                <span>优惠价</span>
                <el-tooltip effect="light" placement="right">
                  <div slot="content">
                    <p>退款页面的优惠价为优惠券、积分、<br />粉币、整单改价的优惠平摊后的价格</p>
                  </div>
                  <i class="iconfont" style="font-size: 14px; color: #d2d2d2">&#xe71a;</i>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.refundType == 0 || scope.row.refundType == 3"
                  v-model="scope.row.refundMoney"
                  size="mini"
                  oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')"
                  @change="refundMoneyChange(scope.$index, scope.row.refundMoney, scope.row.resultPayPrice)"
                ></el-input>
                <span v-else>{{ scope.row.resultPayPrice || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="划扣次数" width="90px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-input
                  v-if="scope.row.refundType == 1 || scope.row.refundType == 4"
                  v-model="scope.row.refundCount"
                  size="mini"
                  oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{0})[\d+\.]/g, '').replace('.','')"
                  @change="refundGoodsChange(scope.$index, scope.row.refundCount, scope.row.deductCount)"
                ></el-input>
                <span v-else>{{ scope.row.deductCount || '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="划扣金额（元）" width="130px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{ scope.row.deductAmount && scope.row.deductAmount > 0 ? scope.row.deductAmount : '--' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="退款类型" width="140px" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <el-select v-model="scope.row.refundType" size="mini" placeholder="请选择" @change="totalRefundMoney">
                  <el-option value="9" label="无">无</el-option>
                  <el-option v-if="!scope.row.deductCount" value="0" label="退金额">退金额</el-option>
                  <el-option v-if="scope.row.itemType == 1" value="2" label="退货">退货</el-option>
                  <el-option v-if="scope.row.deductCount * 1 == scope.row.count * 1" value="1" label="退次数">退次数</el-option>
                  <el-option v-if="scope.row.itemType == 1 && !scope.row.deductCount" value="3" label="退金额退货">退金额退货</el-option>
                  <el-option v-if="scope.row.itemType == 1 && scope.row.deductCount" value="4" label="退次数退货">退次数退货</el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="orderDeatilsData.orderType != 4" class="box">
          <div class="title" style="margin-bottom: 10px">收支明细</div>
          <div class="border">
            <p>
              <span>消费总额：</span>
              <label>￥{{ refundData.initAmount }}</label>
            </p>
            <p>
              <span>优惠金额：</span>
              <label>￥{{ refundData.discountAmount }}</label>
              <el-tooltip
                v-if="refundData.discountDetailList ? (refundData.discountDetailList.length > 0 ? true : false) : false"
                effect="light"
                placement="right"
              >
                <div slot="content">
                  <p v-for="(v, n) in refundData.discountDetailList" :key="n">{{ v.discountType }}：-￥{{ v.discountPrice }}</p>
                </div>
                <i class="iconfont" style="padding-left: 5px; font-size: 14px">&#xe71a;</i>
              </el-tooltip>
            </p>
            <p style="clear: both; display: flex">
              <span>{{ settlementCode == '赊账' ? '赊账' : '实收金额' }}：</span>
              <label style="color: #ff4949 !important; font-weight: bold"
                >￥<b style="font-size: 18px; font-weight: bold">{{ Lib.getValue(1, refundData.resultAmount) }}</b
                >{{ Lib.getValue(2, refundData.resultAmount) }}</label
              >
              <b v-if="settlementCode != '赊账' && settlementCode != '部分支付'">（{{ refundData.payTypeName }}）</b>
            </p>
            <p v-if="settlementCode == '赊账' || settlementCode == '部分支付'">
              <span>{{ settlementCode == '赊账' ? '未还金额：' : '剩余款项：' }}</span>
              <label>￥{{ settlementCode == '赊账' ? refundData.onAccountNoRefundAmount : refundData.balance }}</label>
              <b
                v-if="
                  (settlementCode == '赊账' && !refundData.onAccountNoRefundAmount) ||
                  (settlementCode == '部分支付' && refundData.balance * 1 == 0)
                "
                style="padding-left: 5px; color: #999"
                >(已还清)</b
              >
            </p>
            <p v-if="refundData.refundMsg4OrderVo">
              <span>已退款：</span>
              <label
                >￥{{
                  refundData.refundMsg4OrderVo
                    ? refundData.refundMsg4OrderVo.amount
                      ? refundData.refundMsg4OrderVo.amount
                      : '0.00'
                    : '0.00'
                }}</label
              >
            </p>
          </div>
        </div>
        <div class="box">
          <div class="title" style="margin-bottom: 10px">
            <span>退款明细</span>
            <el-popover placement="right" trigger="hover">
              <div style="padding: 10px; max-width: 420px">
                <p>1.已经使用过的积分、粉币、优惠券不能退还。</p>
                <p v-if="settlementCode == '部分支付'">
                  2.部分支付的剩余款项大于退款合计时，退款直接在剩余款项扣除；剩余款项小于退款合计时，退款在剩余款项中扣除后，剩下的退款通过现金退回顾客
                </p>
                <p v-if="settlementCode == '赊账'">
                  2.赊账的未还金额大于退款合计时，退款直接在未还金额扣除；未还金额小于退款合计时，退款在未还金额中扣除后，剩下的退款通过现金退回顾客
                </p>
              </div>
              <i slot="reference" style="color: #d2d2d2; font-size: 14px" class="el-icon-warning"></i>
            </el-popover>
          </div>
          <div class="border">
            <p v-if="orderDeatilsData.orderType == 4" style="padding-left: 10px">直接划扣订单不能退钱</p>
            <p v-if="settlementCode == '优惠全额抵扣'" style="padding-left: 10px">优惠全额抵扣不能退金额</p>
            <p v-if="orderDeatilsData.orderType != 4 && settlementCode != '优惠全额抵扣'">
              <span style="width: 146px">退款合计：</span>
              <label>￥{{ (refundTotal * 1).toFixed(2) }}</label>
            </p>
            <div v-if="settlementCode == '赊账' || refundData.balance * 1 > 0">
              <p v-if="settlementCode == '赊账' && !refundData.onAccountNoRefundAmount ? false : true">
                <span style="width: 146px">{{ settlementCode == '赊账' ? '未还金额扣除：' : '剩余款项扣除：' }}</span>
                <label
                  >￥{{
                    settlementCode == '赊账'
                      ? refundData.onAccountNoRefundAmount > refundTotal
                        ? refundTotal
                        : refundData.onAccountNoRefundAmount
                      : refundData.balance * 1 > refundTotal
                      ? refundTotal
                      : refundData.balance
                  }}</label
                >
              </p>
              <p
                v-if="
                  settlementCode == '赊账'
                    ? refundTotal * 1 > refundData.onAccountNoRefundAmount * 1 && cashPayMoney > 0
                    : refundTotal * 1 > refundData.balance * 1 && cashPayMoney
                "
              >
                <span style="width: 146px">现金退回：</span>
                <label
                  >￥{{
                    settlementCode == '赊账'
                      ? (refundTotal * 1 - refundData.onAccountNoRefundAmount * 1).toFixed(2)
                      : (refundTotal * 1 - refundData.balance * 1 > cashPayMoney
                          ? cashPayMoney
                          : refundTotal * 1 - refundData.balance * 1
                        ).toFixed(2)
                  }}</label
                >
              </p>
              <p
                v-if="
                  settlementCode == '赊账'
                    ? refundTotal * 1 > refundData.onAccountNoRefundAmount * 1 && payMaxTwo
                    : refundTotal * 1 - refundData.balance * 1 > cashPayMoney
                "
              >
                <span style="width: 146px">会员卡退回：</span>
                <label
                  >￥{{
                    settlementCode == '赊账'
                      ? (refundTotal * 1 - refundData.onAccountNoRefundAmount * 1).toFixed(2)
                      : (refundTotal * 1 - refundData.balance * 1 - cashPayMoney).toFixed(2)
                  }}</label
                >
              </p>
            </div>
            <div
              v-if="
                orderDeatilsData.orderType != 4 &&
                settlementCode != '赊账' &&
                refundData.balance * 1 == 0 &&
                settlementCode != '优惠全额抵扣'
              "
            >
              <h4 v-for="(a, b) in payListData" :key="b">
                <span>{{ a.name }}退回：</span>
                <el-input
                  v-model="a.money"
                  class="qInput"
                  oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')"
                  :disabled="refundTotal * 1 == 0"
                  @input="distributeMoney(3, b)"
                >
                  <template slot="prepend">￥</template>
                </el-input>
                <samp v-if="a.money > a.oldMoney">{{ a.name }}退回金额不可超过￥{{ a.oldMoney }}</samp>
              </h4>
              <h4 v-if="memberPayStatus == 2 || memberPayStatus == 3">
                <span>会员卡退回：</span>
                <el-input
                  v-model="memberReturnVal"
                  class="qInput"
                  :disabled="memberPayStatus == 2 || refundTotal * 1 == 0"
                  oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')"
                  @input="distributeMoney(1)"
                >
                  <template slot="prepend">￥</template>
                </el-input>
                <samp v-if="memberReturnVal > payMaxTwo">会员卡退回金额不可超过￥{{ payMaxTwo }}</samp>
              </h4>
              <h4 v-if="memberPayStatus != 2">
                <span>现金退回：</span>
                <el-input
                  v-model="cashReturnVal"
                  class="qInput"
                  :disabled="(payListData.length == 0 && memberPayStatus == 1) || refundTotal * 1 == 0"
                  oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')"
                  @input="distributeMoney(2)"
                >
                  <template slot="prepend">￥</template>
                </el-input>
              </h4>
            </div>
            <h5>
              <span>备注：</span>
              <label>
                <el-input
                  v-model="refundRemark"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder="请填写退款备注（100字以内）"
                  maxlength="100"
                >
                </el-input>
              </label>
            </h5>
          </div>
        </div>
        <div style="float: right">
          <!-- payMaxHandle() ||  -->
          <el-button type="primary" :disabled="memberReturnVal * 1 > payMaxTwo * 1" @click="comfirmRefund">确 定</el-button>
          <el-button @click="refundDialog = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="退款" :visible.sync="quickRefundDialog" :append-to-body="true" width="1000px">
      <div class="quickRefund">
        <p>
          <span>实收金额：</span>
          <label
            >￥ <samp>{{ Lib.getValue(1, refundData.payAmount) }}</samp
            >{{ Lib.getValue(2, refundData.payAmount) }}</label
          >
        </p>
        <h4>
          <span>现金退回：</span>
          <el-input
            v-model="quickRefundMoney"
            class="qInput"
            oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')"
            @change="quickChange(refundData.payAmount, quickRefundMoney)"
          >
            <template slot="prepend">￥</template>
          </el-input>
        </h4>
        <h5>
          <span>备注：</span>
          <label>
            <el-input
              v-model="quickRefundRemark"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="请填写退款备注（100字以内）"
              maxlength="100"
            >
            </el-input>
          </label>
        </h5>
      </div>
      <div style="float: right; margin: 20px 0">
        <el-button @click="quickRefundDialog = false">取 消</el-button>
        <el-button type="primary" @click="comfirmRefund">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="退款授权" :visible.sync="authorizeDialog" :append-to-body="true" width="360px">
      <div class="authorize">
        <p>现场扫码授权</p>
        <img :src="qrCodeUrl" />
        <p>请打开app扫码授权</p>
      </div>
    </el-dialog>

    <el-dialog title="取消退款" :visible.sync="cancelDialog" :append-to-body="true" width="580px">
      <div>确认进行取消退款操作？</div>
      <div style="float: right; margin: 20px 0 10px 0">
        <el-button @click="cancelDialog = false">取 消</el-button>
        <el-button type="primary" @click="comfirmCancelRefund">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { parseJSON } from 'date-fns';
// eslint-disable-next-line import/no-unresolved
import axios from '@/http/index'
import {
  getPrintSetList,
  printOrder,
  getDragPrintTemplate,
  dragPrintPreview,
  dragPrint,
  // getRefundItemMsg,
  saveOrUpdateRefundMsg,
  obtainGainQRCode,
  getRefundPayStatus,
  getRefundPayAuthStatus,
  getRefundItemMsg,
} from '../api'

export default {
  props: {
    orderDeatilsData: {
      type: Object,
      default: () => {},
    },
    orderCode: {
      type: String,
      default: '',
    },
    orderTypeName: {
      type: String,
      default: '',
    },
    settlementCode: {
      type: String,
      default: String,
    },
  },
  data() {
    return {
      // isDesktop: window.sessionStorage.isDesktop * 1, // 判断是否是客户端 0不是  1是
      // ishd: window.sessionStorage.ishd ? 1 : 0, // 判断是否是HD  0不是  1是
      // 打印模块所需参数
      printerList: [], // 打印机列表
      printerId: '', // 打印机ID
      printerName: '', // 打印机名称
      refreshStatus: false, // 刷新状态
      detailsDialog: false,
      templateList: [], // A4打印模板列表
      showTemplateList: false, // 是否展示-A4打印模板列表
      templateIem: {}, // 选中的模板
      showTemplate: false, //  是否展示-A4打印模板
      templateData: '', // A4模板内容
      templateDataArr: '', // A4模板内容
      // 退款模块所需参数
      quickRefundMoney: '', // 快捷收银现金回退金额
      quickRefundRemark: '', // 快捷收银退款备注
      memberPayStatus: 1, // 会员卡支付状态
      payMaxTwo: 0, // 会员卡退回最大值
      cashPayMoney: 0, // 现金退回最大值
      IsAq: window.sessionStorage.IsAq || 1, // 安全设置-客户端签名开关
      payListData: [], // 微信或支付宝支付的支付列表及金额

      refundDialog: false, // 退款--弹窗
      quickRefundDialog: false, // 快捷退款--弹窗
      authorizeDialog: false, // 退款授权--弹窗
      cancelDialog: false, // 取消退款--弹窗
      wxReturnVal: '0.00', // 微信--通联回退金额
      memberReturnVal: '0.00', // 会员卡回退金额
      cashReturnVal: '0.00', // 现金回退金额

      qrCodeUrl: '', // 退款授权二维码
      clearRefundPayAuthStatus: null, // 退款授权监听状态
      refundData: {
        vipCardMsg4RefundList: [],
      },
      refundTotal: 0, // 退款合计金额
      refundRemark: '', // 退款备注

      pageNum: 1, // 列表页码
      total: 1, // 列表总数
      // orderData: {}, // 订单列表信息
    }
  },
  watch: {
    // array() {
    //   this.update = false;
    //   this.$nextTick(() => {
    //     this.update = true;
    //   });
    // },
    // detailsCol() {
    //   this.detailsUpdate = false;
    //   this.$nextTick(() => {
    //     this.detailsUpdate = true;
    //   });
    // },
    orderDeatilsData(val) {
      if (val) {
        console.log('val', val)
        this.getPrinterList()
      }
      // this.newCheckList = val;
      // true;
    },
  },
  mounted() {
    // this.orderData = window.JSON.parse(window.sessionStorage.orderData);
    // this.getPrinterList();
    // this.getTemplate();
    this.$emit('tansferDialog', this.detailsDialog)
  },
  methods: {
    // 获取状态
    getStatus(orderDeatilsData) {
      // refundStatus订单还款状态(0:没有退款，1：退款中，2：退款失败，3：部分退款，4：全部退款)

      // :orderDeatilsData.bookOrderMsgDTO.bookStatus==-1?'已取消-商家取消'
      //           :orderDeatilsData.bookOrderMsgDTO.bookStatus==-2?'已取消-预约过期':orderDeatilsData.bookOrderMsgDTO.bookStatus==-3?'已取消-用户取消':orderDeatilsData.bookOrderMsgDTO.bookStatus==-4?'已取消-商家拒绝':'已取消

      if (orderDeatilsData.refundStatus == 0) {
        return orderDeatilsData.partPayType == 1 && orderDeatilsData.balance > 0
          ? '部分支付'
          : orderDeatilsData.orderStatus == 2
          ? '已结算'
          : orderDeatilsData.orderStatus == 1
          ? '待结算'
          : '已结算'
      }
      return orderDeatilsData.refundStatus == 1
        ? '退款中'
        : orderDeatilsData.refundStatus == 2
        ? '退款失败'
        : orderDeatilsData.refundStatus == 3
        ? '已退款-部分退款'
        : '已退款-全部退款'
      // 之前的判断
      // return orderDeatilsData.refundStatus == 1 ? '退款中'
      //   : orderDeatilsData.refundStatus == 2 ? '退款失败'
      //     : orderDeatilsData.refundStatus == 3 && orderDeatilsData.bookOrderMsgDTO ? orderDeatilsData.bookOrderMsgDTO.bookStatus !== -4 ? '已退款-部分退款'
      //       : '已退款-部分退款' : orderDeatilsData.refundStatus == 3 && orderDeatilsData.bookOrderMsgDTO ? orderDeatilsData.bookOrderMsgDTO.bookStatus === -4 ? '已退款-全部退款' : '已退款-全部退款'
      //       : orderDeatilsData.refundStatus == 4 && orderDeatilsData.partPayType == 1 ? '部分支付'
      //         : '已退款-全部退款';
    },
    // 获取颜色
    // 待结算- 红色;已结算 -绿色; 部分支付-橙色- 退款-蓝色
    getClass(orderDeatilsData) {
      if (orderDeatilsData.refundStatus == 0) {
        return orderDeatilsData.partPayType == 1 && orderDeatilsData.balance > 0
          ? 'order-h1-cse'
          : orderDeatilsData.orderStatus == 2
          ? 'order-h1-lse'
          : orderDeatilsData.orderStatus == 1
          ? 'order-h1-hse'
          : 'order-h1-lse'
      }
      return 'order-h1-bule'
    },
    // 返回图片icon
    returnImg(orderDeatilsData) {
      // -待结算：icon-a-zu181;-已结算：icon-a-zu180;-部分支付：icon-a-lujing84；-退款：icon-a-lujing85
      if (orderDeatilsData.refundStatus == 0) {
        return orderDeatilsData.partPayType == 1 && orderDeatilsData.balance > 0
          ? 'icon-a-lujing84'
          : orderDeatilsData.orderStatus == 2
          ? 'icon-a-zu180'
          : orderDeatilsData.orderStatus == 1
          ? 'icon-a-zu181'
          : 'icon-a-zu180'
      }
      return 'icon-a-lujing85'
    },
    // 获取打印机列表
    getPrinterList() {
      this.refreshStatus = true
      getPrintSetList({
        printType: this.orderDeatilsData.orderType == 2 ? 31 : 30,
      }).then((res) => {
        if (res && res.code == 0) {
          this.refreshStatus = false
          this.printerList = res.data
          let pNum = 'null'
          if (res.data) {
            res.data.forEach((v, n) => {
              if (v.printerState == 1) {
                pNum = pNum == 'null' ? n : n > pNum ? pNum : n
              }
            })
            if (pNum == 'null') {
              this.printerId = ''
              this.printerName = '暂无可用设备'
            } else {
              this.printerId = res.data[pNum].id
              this.printerName = res.data[pNum].printerName
            }
          }
        } else {
          this.refreshStatus = true
        }
      })
    },

    // 打印小票
    printOrder(num) {
      const data = {
        orderId: this.orderDeatilsData.orderId,
        mainId: window.sessionStorage.mainId,
        printType: this.orderDeatilsData.orderType, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
        printId: this.printerId,
        isManual: num ? 1 : 0,
      }
      printOrder(data).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 2000,
            onClose: () => {
              this.detailsDialog = false
            },
          })
        }
      })
    },
    // A4打印
    aFourPrint() {
      this.showTemplateList = true
      this.getTemplate()
    },
    // 获取针式打印(拖拽)设置的模板
    getTemplate() {
      const data = {
        mainId: window.sessionStorage.mainId,
        // orderId: this.orderData.orderId,
        // orderType: this.orderData.orderType
        orderId: this.orderDeatilsData.orderId,
        orderType: this.orderDeatilsData.orderType,
      }
      getDragPrintTemplate(data).then((res) => {
        if (res.code === 0) {
          this.templateList = res.data
          // this.showTemplateList = true;
        }
      })
    },
    // 选择模板id-打印模板
    selectTemplateId(data) {
      this.templateIem = data
      const obj = {
        orderId: this.orderDeatilsData.orderId,
        mainId: window.sessionStorage.mainId,
        templateId: data.id,
        useScene: data.useScene,
        orderType: this.orderDeatilsData.orderType,
      }
      dragPrintPreview(obj).then((res) => {
        if (res.code === 0) {
          this.templateDataArr = JSON.parse(res.data)
          this.templateData = JSON.parse(res.data)[this.pageNum - 1]
          this.total = JSON.parse(res.data).length
          this.showTemplate = true
        }
      })
    },
    handleSizeChange(val) {
      this.pageNum = val
      this.templateData = this.templateDataArr[this.pageNum - 1]
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.templateData = this.templateDataArr[this.pageNum - 1]
    },
    // 选择打印机
    saveDy() {
      const obj = {
        orderId: this.orderDeatilsData.orderId,
        mainId: window.sessionStorage.mainId,
        templateId: this.templateIem.id,
        useScene: this.templateIem.useScene,
        orderType: this.orderDeatilsData.orderType,
      }
      dragPrint(obj).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '打印成功',
            type: 'success',
          })
        }
      })
    },
    openpdf() {
      axios({
        url: '/export/pdf/download/pdf',
        method: 'post',
        data: { content: this.templateData },
        responseType: 'blob',
      }).then((res) => {
        const blob = new Blob([res.data], { type: 'application/octet-stream' }) // 构造一个blob对象来处理数据
        const elink = document.createElement('a') // 创建a标签
        elink.download = '美业订单单据.pdf' // a标签添加属性
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click() // 执行下载
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink) // 释放标签
      })
    },
    // 选择打印机
    choosePrinter(val) {
      this.printerId = val.split(',')[0]
      this.printerName = val.split(',')[1]
    },
    // 前往后台设置打印机
    jumpSetPrinter() {
      window.open(window.sessionStorage.setUrl4Print)
    },
    // 退款=================================================
    reset() {
      this.payListData.forEach((a) => {
        a.money = 0
      })
    },
    // 取消退款--弹窗
    cancelRefund() {
      this.cancelDialog = true
    },
    // 确定取消退款
    comfirmCancelRefund() {},
    // 退款按钮显示和隐藏
    refundBtnStatus() {
      const newNum = 0
      if (newNum == this.orderDeatilsData.itemList.length && this.orderDeatilsData.itemList.length != 0) {
        return false
      }
      return true
    },
    // 退款
    refund(type, id) {
      if (type == 2) {
        this.quickRefundMoney = ''
        this.quickRefundRemark = ''
        this.quickRefundDialog = true
      } else {
        this.refundTotal = 0
        this.refundRemark = ''
        this.reset()
        this.memberReturnVal = '0.00'
        this.cashReturnVal = '0.00'
        this.refundDialog = true
      }
      const data = {
        id,
        orderType: type,
      }
      getRefundItemMsg(data).then((res) => {
        if (res.code == 0) {
          if (res.data.itemList) {
            res.data.itemList.forEach((a) => {
              a.refundType = '9'
              a.refundCount = '0'
              a.refundNum = '0'
              a.refundMoney = '0'
              if (res.data.orderType == 4) {
                a.deductAmount = a.resultPrice
                a.deductCount = a.count
              }
            })
          }
          this.memberPayStatus = 1
          if (res.data.payTypeList) {
            const newArr = []
            let cashTotal = 0
            res.data.payTypeList.forEach((b) => {
              if (b.payType == 9) {
                newArr.push({
                  name: '微信-官方',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 10) {
                newArr.push({
                  name: '支付宝-官方',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 11) {
                newArr.push({
                  name: '微信-通联',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 12) {
                newArr.push({
                  name: '支付宝-通联',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 13) {
                newArr.push({
                  name: '微信-翼支付',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 14) {
                newArr.push({
                  name: '支付宝-翼支付',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 15) {
                newArr.push({
                  name: '微信-合利宝',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 16) {
                newArr.push({
                  name: '支付宝-合利宝',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 17) {
                newArr.push({
                  name: '微信-收银宝',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 18) {
                newArr.push({
                  name: '支付宝-收银宝',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 23) {
                newArr.push({
                  name: '货款余额',
                  money: 0,
                  oldMoney: b.money * 1,
                  originOrderCode: b.originOrderCode,
                })
              } else if (b.payType == 3) {
                if (res.data.payTypeList.length == 1) {
                  this.memberPayStatus = 2
                } else {
                  this.memberPayStatus = 3
                }
                this.payMaxTwo = b.money * 1
              }
              if (b.payType != 3 && b.payType != 5) {
                cashTotal += b.money * 1
              }
            })
            this.payListData = newArr
            this.cashPayMoney = cashTotal
          }
          this.refundData = res.data
        }
      })
    },
    quickChange(old, edit) {
      if (edit * 1 > old * 1) {
        this.quickRefundMoney = (old * 1).toFixed(2)
      }
    },
    // 确认退款--提交数据
    authRefundSuccess() {
      const vm = this
      const arr = []
      let data = {}
      let payArr = []
      if (vm.refundData.itemList) {
        vm.refundData.itemList.forEach((a) => {
          if (a.refundType != '9') {
            // 有选退款类型的数据--进行数据重组
            const obj = {}
            obj.afterAmount = a.refundMoney
            obj.amount = a.refundType == 0 || a.refundType == 3 ? a.resultPayPrice * 1 - a.refundMoney * 1 : 0
            if (a.refundType == 2 || a.refundType == 3 || a.refundType == 4) {
              obj.goodCount = (a.count * 1 - a.refundNum * 1).toFixed(0)
            } else {
              obj.goodCount = 0
            }
            if (a.refundType == 1 || a.refundType == 4) {
              obj.count = (a.count * 1 - a.refundCount * 1).toFixed(0)
            } else if (a.refundType == 0 || a.refundType == 3) {
              obj.count = a.count
            } else {
              obj.count = 0
            }
            obj.deductType = a.deductType
            obj.itemId = a.itemId
            obj.itemType = a.itemType
            obj.orderId = vm.refundData.orderId
            obj.orderItemId = a.orderItemId
            obj.refundType = a.refundType
            arr.push(obj)
          }
        })
      }
      if (vm.refundData.orderType == 2) {
        data = {
          amount: vm.quickRefundMoney,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: 2,
          payItemList: [
            {
              amount: vm.quickRefundMoney,
              payType: 1,
            },
          ],
          refundItemList: null,
          remark: vm.quickRefundRemark,
        }
      } else if (vm.refundData.orderType == 4) {
        data = {
          amount: 0,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: 4,
          payItemList: [
            {
              amount: 0,
              payType: 0,
            },
          ],
          refundItemList: arr,
          remark: vm.refundRemark,
        }
      } else if (vm.settlementCode == '赊账') {
        payArr = []
        if (vm.refundData.onAccountNoRefundAmount) {
          if (vm.refundData.onAccountNoRefundAmount * 1 >= vm.refundTotal * 1) {
            payArr.push({
              amount: vm.refundTotal,
              payType: 21,
            })
          }
        } else if (vm.payMaxTwo && vm.cashPayMoney) {
          if (vm.refundTotal > vm.cashPayMoney) {
            payArr.push(
              {
                amount: vm.cashPayMoney,
                payType: 1,
              },
              {
                amount: (vm.refundTotal * 1 - vm.cashPayMoney).toFixed(2),
                payType: 3,
              }
            )
          } else {
            payArr.push({
              amount: vm.cashPayMoney,
              payType: 1,
            })
          }
        } else {
          payArr.push({
            amount: vm.refundTotal,
            payType: vm.cashPayMoney ? 1 : 3,
          })
        }
        data = {
          amount: vm.refundTotal,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: payArr,
          refundItemList: arr,
          remark: vm.refundRemark,
        }
      } else if (vm.refundData.balance * 1 > 0) {
        payArr = []
        if (vm.refundTotal * 1 - vm.refundData.balance * 1 > vm.cashPayMoney) {
          payArr.push(
            {
              amount: vm.cashPayMoney,
              payType: 1,
            },
            {
              amount: (vm.refundTotal * 1 - vm.refundData.balance * 1 - vm.cashPayMoney).toFixed(2),
              payType: 3,
            },
            {
              amount: vm.refundData.balance,
              payType: 20,
            }
          )
        } else if (vm.refundTotal * 1 > vm.refundData.balance * 1) {
          payArr.push(
            {
              amount: (vm.refundTotal * 1 - vm.refundData.balance * 1).toFixed(2),
              payType: 1,
            },
            {
              amount: vm.refundData.balance,
              payType: 20,
            }
          )
        } else {
          payArr.push({
            amount: vm.refundTotal,
            payType: 20,
          })
        }
        data = {
          amount: vm.refundTotal,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: payArr,
          refundItemList: arr,
          remark: vm.refundRemark,
        }
      } else if (vm.settlementCode == '优惠全额抵扣') {
        data = {
          amount: 0,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: [
            {
              amount: 0,
              payType: 0,
            },
          ],
          refundItemList: arr,
          remark: vm.refundRemark,
        }
      } else {
        payArr = []
        vm.payListData.forEach((a) => {
          payArr.push({
            amount: a.money,
            payType:
              a.name == '微信-官方'
                ? 9
                : a.name == '支付宝-官方'
                ? 10
                : a.name == '微信-通联'
                ? 11
                : a.name == '支付宝-通联'
                ? 12
                : a.name == '微信-翼支付'
                ? 13
                : a.name == '支付宝-翼支付'
                ? 14
                : a.name == '微信-合利宝'
                ? 15
                : a.name == '支付宝-合利宝'
                ? 16
                : a.name == '微信-收银宝'
                ? 17
                : a.name == '支付宝-收银宝'
                ? 18
                : 23,
            originOrderCode: a.originOrderCode,
          })
        })
        if (vm.memberPayStatus != 1) {
          payArr.push({
            amount: vm.memberReturnVal,
            payType: 3,
          })
        }
        if (vm.memberPayStatus != 2) {
          payArr.push({
            amount: vm.cashReturnVal,
            payType: 1,
          })
        }
        data = {
          amount: vm.refundTotal,
          mainId: window.sessionStorage.mainId,
          orderId: vm.refundData.orderId,
          orderType: vm.refundData.orderType,
          payItemList: payArr,
          refundItemList: arr,
          remark: vm.refundRemark,
        }
      }
      saveOrUpdateRefundMsg(data).then((res) => {
        if (res.code == 0) {
          vm.quickRefundDialog = false
          vm.authorizeDialog = false
          vm.refundDialog = false
          vm.$emit('tansferDialog', false)
          vm.$emit('newGetListData', '')
          vm.refundTotal = 0
          vm.quickRefundRemark = ''
          vm.refundRemark = ''
          vm.reset()
          vm.memberReturnVal = 0
          vm.cashReturnVal = 0
          vm.$message({ type: 'success', message: '操作成功' })
          vm.getRefundPayStatus()
        }
      })
    },
    // 修改退款分配金额
    distributeMoney(val, index) {
      const vm = this
      if (vm.payListData.length > 0 && vm.memberPayStatus == 3) {
        if (val == 1) {
          if (vm.memberReturnVal * 1 > vm.payMaxTwo * 1) {
            vm.$message(`会员卡退回金额不可超过￥${vm.payMaxTwo * 1 > vm.refundTotal * 1 ? vm.refundTotal : vm.payMaxTwo}`)
            let newTotal = 0
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1
            })
            const r1 = vm.refundTotal * 1 > vm.payMaxTwo * 1 + newTotal ? vm.payMaxTwo * 1 : vm.refundTotal * 1
            if (r1 == vm.refundTotal * 1) {
              vm.reset()
              vm.memberReturnVal = r1
              vm.cashReturnVal = (vm.refundTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
            } else {
              vm.memberReturnVal = r1
              vm.cashReturnVal = (Math.abs(vm.refundTotal * 1 - newTotal - vm.memberReturnVal * 1) * 1).toFixed(2)
            }
          } else {
            let newTotal = 0
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1
            })
            const r1 = vm.refundTotal * 1 >= vm.memberReturnVal * 1 + newTotal ? vm.memberReturnVal * 1 : vm.refundTotal * 1
            if (r1 == vm.refundTotal * 1 && vm.memberReturnVal * 1 != vm.payMaxTwo * 1) {
              vm.reset()
              vm.memberReturnVal = r1
              vm.cashReturnVal = (vm.refundTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
            } else {
              // vm.memberReturnVal = r1;
              vm.cashReturnVal = (Math.abs(vm.refundTotal * 1 - newTotal - vm.memberReturnVal * 1) * 1).toFixed(2)
            }
          }
        } else if (val == 2) {
          if (vm.cashReturnVal * 1 > vm.refundTotal * 1) {
            vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
            vm.memberReturnVal = 0
            vm.reset()
          } else {
            let newTotal = 0
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1
            })
            const r1 = vm.refundTotal * 1 >= vm.cashReturnVal * 1 + newTotal ? vm.cashReturnVal * 1 : vm.refundTotal * 1
            if (r1 == vm.refundTotal * 1) {
              vm.reset()
              vm.cashReturnVal = r1
              vm.memberReturnVal = (vm.refundTotal * 1 - vm.cashReturnVal * 1).toFixed(2)
            } else {
              // vm.cashReturnVal = r1;
              vm.memberReturnVal = (vm.refundTotal * 1 - newTotal - vm.cashReturnVal * 1).toFixed(2)
            }
          }
        } else if (val == 3) {
          if (vm.refundTotal * 1 > vm.payListData[index].money * 1) {
            if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
              vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.payListData[index].oldMoney}`)
              vm.payListData[index].money = vm.payListData[index].oldMoney
              let newTotal = 0
              vm.payListData.forEach((c) => {
                newTotal += c.money * 1
              })
              vm.memberReturnVal = 0
              vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
            } else {
              let newTotal = 0
              vm.payListData.forEach((c) => {
                newTotal += c.money * 1
              })
              vm.memberReturnVal = 0
              vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
            }
          } else if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
            vm.$message(
              `${vm.payListData[index].name}退回金额不可超过￥${
                vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal
              }`
            )
            vm.payListData[index].money =
              vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal
            let newTotal = 0
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1
            })
            vm.memberReturnVal = 0
            vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
          } else {
            vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.refundTotal}`)
            vm.payListData[index].money = vm.refundTotal
            let newTotal = 0
            vm.payListData.forEach((c) => {
              newTotal += c.money * 1
            })
            vm.memberReturnVal = 0
            vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
          }
        } else {
          vm.reset()
          vm.memberReturnVal = 0
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
        }
      } else if (vm.memberPayStatus == 3 && vm.payListData.length == 0) {
        if (val == 1) {
          if (vm.memberReturnVal * 1 > vm.refundTotal * 1) {
            vm.memberReturnVal = (vm.refundTotal * 1).toFixed(2)
            vm.reset()
            vm.cashReturnVal = 0
          } else {
            vm.reset()
            vm.cashReturnVal = (vm.refundTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
          }
        } else if (val == 2) {
          if (vm.cashReturnVal * 1 > vm.refundTotal * 1) {
            vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
            vm.memberReturnVal = 0
            vm.reset()
          } else {
            vm.reset()
            vm.memberReturnVal = (vm.refundTotal * 1 - vm.cashReturnVal * 1).toFixed(2)
          }
        } else {
          vm.reset()
          vm.memberReturnVal = 0
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
        }
      } else if (vm.memberPayStatus == 1 && vm.payListData.length > 0) {
        if (val == 3) {
          vm.refundCone(index)
        } else if (val == 2) {
          if (vm.cashReturnVal * 1 > vm.refundTotal * 1) {
            vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
            vm.memberReturnVal = 0
            vm.reset()
          } else {
            vm.reset()
            vm.memberReturnVal = (vm.refundTotal * 1 - vm.cashReturnVal * 1).toFixed(2)
          }
        } else {
          vm.reset()
          vm.memberReturnVal = 0
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
        }
      } else if (vm.memberPayStatus == 2) {
        if (vm.refundData.balance * 1 > 0) {
          vm.reset()
          vm.memberReturnVal = 0
          vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
        } else {
          vm.reset()
          vm.memberReturnVal = (vm.refundTotal * 1).toFixed(2)
          vm.cashReturnVal = 0
        }
      } else {
        vm.reset()
        vm.memberReturnVal = 0
        vm.cashReturnVal = (vm.refundTotal * 1).toFixed(2)
      }
    },
    // 退款步骤简化一
    refundCone(index) {
      const vm = this
      if (vm.refundTotal * 1 > vm.payListData[index].money * 1) {
        if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
          vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.payListData[index].oldMoney}`)
          vm.payListData[index].money = vm.payListData[index].oldMoney
          vm.refundCtwo(index)
        } else {
          vm.refundCtwo(index)
        }
      } else if (vm.payListData[index].money * 1 > vm.payListData[index].oldMoney * 1) {
        vm.$message(
          `${vm.payListData[index].name}退回金额不可超过￥${
            vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal
          }`
        )
        vm.payListData[index].money =
          vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal
        vm.refundCtwo(index)
      } else {
        vm.$message(`${vm.payListData[index].name}退回金额不可超过￥${vm.refundTotal}`)
        vm.payListData[index].money = vm.refundTotal
        vm.refundCtwo(index)
      }
    },
    // 退款步骤简化二
    refundCtwo(index) {
      const vm = this
      let newTotal = 0
      vm.payListData.forEach((c) => {
        newTotal += c.money * 1
      })
      if (newTotal > vm.refundTotal * 1) {
        vm.reset()
        vm.payListData[index].money =
          vm.refundTotal * 1 > vm.payListData[index].oldMoney * 1 ? vm.payListData[index].oldMoney : vm.refundTotal
        vm.memberReturnVal = 0
        vm.cashReturnVal = (vm.refundTotal * 1 - vm.payListData[index].money * 1 - vm.memberReturnVal * 1).toFixed(2)
      } else {
        vm.memberReturnVal = 0
        vm.cashReturnVal = (vm.refundTotal * 1 - newTotal * 1 - vm.memberReturnVal * 1).toFixed(2)
      }
    },
    // 修改退款--退货
    refundNumChange(index, num, count) {
      if (num * 1 > count * 1) {
        this.refundData.itemList[index].refundNum = count
      }
      this.totalRefundMoney()
    },
    // 修改退款--退次数
    refundGoodsChange(index, num, count) {
      if (num * 1 > count * 1) {
        this.refundData.itemList[index].refundCount = count
      }
      this.totalRefundMoney()
    },
    // 修改退款优惠价--退款
    refundMoneyChange(index, num, count) {
      if (num * 1 > count * 1) {
        this.refundData.itemList[index].refundMoney = count
      }
      this.totalRefundMoney()
    },
    // 计算退款合计金额
    totalRefundMoney() {
      let total = 0
      this.refundData.itemList.forEach((a) => {
        if (a.refundType == '0') {
          // 退金额：计算实际退款金额
          total = (total * 1 + (a.resultPayPrice - a.refundMoney)).toFixed(2)
        } else if (a.refundType == '2') {
          // 退货：按退货数量计算退款金额
          const unitPrice = a.resultPayPrice / a.count
          total = (total * 1 + unitPrice * a.refundNum).toFixed(2)
        } else if (a.refundType == '1') {
          // 退次数：按退次数计算退款金额（针对套餐划扣）
          if (a.deductAmount && a.deductCount) {
            const unitDeductAmount = a.deductAmount / a.deductCount
            total = (total * 1 + unitDeductAmount * a.refundCount).toFixed(2)
          }
        } else if (a.refundType == '3') {
          // 退金额退货：按退货数量计算，再减去优惠价
          // 先按退货数量计算退款金额
          const unitPrice = a.resultPayPrice / a.count
          const goodsRefund = unitPrice * a.refundNum
          // 再减去用户输入的优惠价金额
          const finalRefund = goodsRefund - a.refundMoney
          // 确保退款金额不为负数
          total = (total * 1 + Math.max(0, finalRefund)).toFixed(2)
        } else if (a.refundType == '4') {
          // 退次数退货：按退货数量计算退款金额
          const unitPrice = a.resultPayPrice / a.count
          total = (total * 1 + unitPrice * a.refundNum).toFixed(2)
        }
      })
      this.refundTotal = total
      this.distributeMoney()
    },
    payMaxHandle() {
      let pnum = 0
      this.payListData.forEach((a) => {
        if (a.oldMoney * 1 >= a.money * 1) {
          pnum++
        }
      })
      return this.payListData.length == pnum
    },
    // 确认退款
    comfirmRefund() {
      // || this.payMaxHandle()
      if (this.memberReturnVal > this.payMaxTwo) {
        this.$message('请填写正确的退回金额')
        return
      }
      let returnStatus = 1
      if (this.refundData.itemList) {
        this.refundData.itemList.forEach((a) => {
          if (a.refundType != '9') {
            returnStatus = 2
          }
        })
      }
      if (returnStatus == 1 && this.refundData.orderType != 2) {
        this.$message('请选择退款类型')
        return
      }
      if (this.refundData.refundAuth == 1) {
        this.authRefundSuccess()
        return
      }
      this.authorizeDialog = true
      const data = {
        orderCode: this.refundData.orderCode,
      }
      obtainGainQRCode(data).then((res) => {
        if (res.code == 0) {
          this.qrCodeUrl = this.Lib.A() + res.data.url
          this.getRefundPayAuthStatus()
        }
      })
    },
    // 获得退款状态
    getRefundPayStatus() {
      const data = {
        orderCode: this.refundData.orderCode,
      }
      getRefundPayStatus(data).then((res) => {
        if (res.code == 0) {
          this.$emit('reInitData')
          // console.log(res);
        }
      })
    },
    // 获得退款授权状态
    getRefundPayAuthStatus() {
      const vm = this
      vm.clearRefundPayAuthStatus = setInterval(() => {
        const data = {
          orderCode: vm.refundData.orderCode,
        }
        getRefundPayAuthStatus(data).then((res) => {
          if (res.code == 0) {
            // 0:退款授权中，1：退款授权成功，2：退款授权失败
            if (res.data.status == 0) {
              // vm.$message('退款授权中')
              // vm.authRefundSuccess()
              // clearInterval(vm.clearRefundPayAuthStatus)
            } else if (res.data.status == 1) {
              vm.$message({ message: '退款授权成功', type: 'success' })
              clearInterval(vm.clearRefundPayAuthStatus)
              vm.authRefundSuccess()
            } else if (res.data.status == 2) {
              vm.$message.error('退款授权失败')
              clearInterval(vm.clearRefundPayAuthStatus)
            }
          } else {
            clearInterval(vm.clearRefundPayAuthStatus)
          }
        })
      }, 1000)
    },
  },
}
</script>
<style lang="less" scoped>
.order-h1 {
  width: 100%;
  height: 24px;
  font-size: 18px;
  color: #2ac410;
  line-height: 24px;
  padding-bottom: 20px;
}
.order-h1-hse {
  color: #ff4949ff;
}
.order-h1-lse {
  color: #2ac410;
}
.order-h1-cse {
  color: #ff8000ff;
}
.order-h1-bule {
  color: #00a8ffff;
}
.order-h1-djs {
}
.order-h2 {
  font-size: 18px;
  color: #333333;
  height: 36px;
  line-height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.order-h2-left span {
  margin-left: 100px;
}
.order-h2-right {
  display: flex;
  i {
    color: #aaa;
  }
  .order-dropdown {
    margin-right: 10px;
  }
  .titlte {
    padding: 0 5px;
  }
}

// 打印
.order_mode {
  display: none;
  display: flex;
}
.order_ul {
  list-style-type: none;
  cursor: pointer;
}
.order_ul li {
  width: 120px;
  text-align: left;
  font-size: 14px;
  color: #333333;
  padding: 13px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.order_ul_icon {
  font-size: 12px;
  color: #bcc1ce;
  text-align: right;
}
.order_template {
  list-style-type: none;
  cursor: pointer;
  border-left: 1px solid #e6ebf5;
  height: 140px;
  overflow: auto;
}
.order_template_name {
  text-align: left;
  font-size: 14px;
  color: #333333;
  padding: 13px 20px;
  min-width: 120px;
}
/*A4打印*/
.a4-template-care {
  max-height: 400px;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  li {
    display: block;
    width: 300px;
    margin: 0 auto 10px;
    display: inline-block;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    color: #606266;
    text-align: center;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
  }
}
.a4-template-care-no {
  padding-bottom: 30px;
}
.a4-template-html {
  position: relative;
  min-height: 600px;
  margin-left: -10%;
}

/*退款 */
.order-details {
  width: 100%;
}
.order-popover {
  padding: 10px;
  min-width: 400px;
  p {
    width: 100%;
    color: #6cc3f5ff;
    height: 28px;
    line-height: 28px;
    .title {
      width: 28px;
      height: 17px;
      text-align: center;
      font-size: 12px;
      line-height: 17px;
      border-radius: 4px;
      display: inline-block;
      margin-right: 7px;
      vertical-align: top;
      margin-top: 4px;
    }
    .text {
      font-size: 13px;
      color: #5a5e66;
      display: inline-block;
    }
    .backg-bule {
      background: #dcf6ff;
      border: 1px solid #c1e4fb;
      color: #6cc3f5ff;
    }
    .backg-gree {
      background: #f0f9eb;
      border: 1px solid #e1f3d8;
      color: #67c23aff;
    }
    .mgl {
      width: calc(100% - 60%);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .textright {
      width: 40%;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.quickRefund {
  clear: both;
  p {
    height: 35px;
    line-height: 33px;
    font-size: 14px;
    color: #333;

    span {
      float: left;
      width: 70px;
      text-align: right;
    }

    label {
      float: left;
      font-weight: bold;
      padding-left: 10px;
      samp {
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  h4 {
    height: 60px;
    line-height: 60px;
    font-size: 14px;
    color: #333;

    span {
      float: left;
      width: 70px;
      text-align: right;
    }

    .qInput {
      float: left;
      padding-left: 10px;
      width: 220px;
      margin-top: 10px;
    }
  }

  h5 {
    padding: 10px 0;
    height: 54px;
    line-height: 27px;
    font-size: 14px;
    color: #333;

    span {
      float: left;
      width: 70px;
      text-align: right;
    }

    label {
      float: left;
      width: 420px;
      padding-left: 10px;
    }
  }
}
</style>
